import React, { useState, useRef } from 'react';
import axios from 'axios';

import { urls } from '../constants';

import SepaH from './sepaH';

// font awesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faSmileBeam, faPaperPlane, faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const Contact = () => {
    // contact form state
    const[form, setForm] = useState({
        email: '',
        message: ''
    });

    // message for state
    const[message, setMessage] = useState({
        shouldShow: false,
        content: '',
        type: ''
    });

    // to check if email is valid
    const[isEmailValid, setEmailValid] = useState(false);

    // to check if message is valid
    const[isMessageValid, setMessageValid] = useState(false);

    // to check message caracters count
    const[messageCaracters, setMessageCaracters] = useState(0);

    // ref on email field
    const refEmail = useRef('');

    // ref on message field
    const refMessage = useRef('');

    const validateEmail = () => {
        return refEmail.current.value.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };

    const validateMessage = () => {
        return refMessage.current.value.length >= 35;
    }

    // when email field is changed
    const onEmailChange = () => {
        // update for state
        setForm(form => ({
            ...form,
            email: refEmail.current.value
        }));

        // check if email is valid
        if(validateEmail()) {
            setEmailValid(true);
        } else {
            setEmailValid(false);
        }
    };

    // when message field is changed
    const onMessageChange = () => {
        // update for state
        setForm(form => ({
            ...form,
            message: refMessage.current.value
        }));

        // update caracters count
        setMessageCaracters(messageCaracters + 1);

        // check if message is valid
        if(validateMessage()) {
            setMessageValid(true);
        } else {
            setMessageValid(false);
        }
    }

    // when contact form is submitted
    const sendContactForm = (evt) => {
        evt.preventDefault();

        axios.post(urls.contact_url, form)
        .then((response) => {       
            // if email was sent
            if(response.data.status === 200) {
                setMessage(message => ({
                    ...message,
                    shouldShow: true,
                    content: response.data.response,
                    className: 'message-form message-form-success',
                    type: 'success'
                }));
            }

            // if an error occured
            if(response.data.status === 500) {
                setMessage(message => ({
                    ...message,
                    shouldShow: true,
                    content: response.data.response,
                    className: 'message-form message-form-error',
                    type: 'error'
                }));
            }

            // make form empty whatever
            setForm(form => ({
                ...form,
                email: '',
                message: ''
            }));
        });
    };

    const canSendForm = () => {
        return (isEmailValid && isMessageValid);
    }

    return (
        <>
            <div className="content">
                <h2><FontAwesomeIcon icon={faEnvelope} />Nous contacter (0750 688 243)</h2>
                <SepaH />
                <div className="content-text">
                    <div className="contact-avertissement">
                        <q>
                        Les informations saisies dans le formulaire ci-dessous ne sont ni stockées ni échangées / vendues à des tiers. Elles servent juste à envoyer et recevoir un email. <FontAwesomeIcon icon={faSmileBeam} />
                        </q>
                    </div>

                    {
                        message.shouldShow &&
                        <div className={message.className}>
                            <p>
                                {
                                    message.type === 'success' &&
                                    <FontAwesomeIcon icon={faCheckCircle} />
                                }
                                {
                                    message.type === 'error' &&
                                    <FontAwesomeIcon icon={faExclamationTriangle} />
                                }
                                <span>{message.content}</span>
                            </p>
                        </div>
                    }

                    <div className="contact-form-wrapper">
                        <form className="contact-form" onSubmit={sendContactForm}>
                            <div className="form-item">
                                <label htmlFor="email">
                                    <span>Votre email <sup>*</sup>:</span>
                                    {
                                        isEmailValid &&
                                        <FontAwesomeIcon icon={faCheckCircle} />
                                    }   
                                </label>
                                <input 
                                    type="email" 
                                    id="email" 
                                    name="email" 
                                    ref={refEmail}
                                    onChange={onEmailChange}
                                    className="form-control" 
                                    value={form.email}
                                />
                            </div>
                            <div className="form-item">
                                <label htmlFor="message">
                                    <span>Votre message <sup>*</sup> ({messageCaracters} sur 35 caractères minimum) :</span>
                                    {
                                        isMessageValid &&
                                        <FontAwesomeIcon icon={faCheckCircle} />
                                    }
                                </label>
                                <textarea 
                                    name="message" 
                                    id="message" 
                                    ref={refMessage}
                                    onChange={onMessageChange}
                                    className="form-control"
                                    value={form.message}
                                >
                                </textarea>
                            </div>
                            <div className="form-submit">
                                {
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary"
                                        disabled={!canSendForm()}
                                    >
                                        Envoyer <FontAwesomeIcon icon={faPaperPlane} />
                                    </button>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Contact;